import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue"
import { capitalize } from "@/shared/utils/helpers"
import { useConfigStore } from "@/stores/config"
import GgmsCascadeSelect from "./GgmsCascadeSelect.vue"
import { Attribute } from "@/shared/models/attributes"
import { Prototype } from "@/shared/models/config"
import { CascadeChildOption } from "@/shared/models/cascade-option"

interface Props {
    specialVariable?: string
    isTemplateTypeEmail?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsMergeFields',
  props: {
    specialVariable: {},
    isTemplateTypeEmail: { type: Boolean }
  },
  emits: ["addMergeField"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const configStore = useConfigStore()
const emit = __emit

const categories = computed(() =>
    configStore.prototypes.filter((prototype) => ["lead", "agent", "agency"].includes(prototype.typeName))
)

const specialVariableMap = {
    "Welcome user": {
        name: "Verify Email URL",
        value: "user.verifyEmailUrl",
        hasFallback: false,
    },
    "Forgotten password": {
        name: "Reset Password URL",
        value: "user.resetPasswordUrl",
        hasFallback: false,
    },
    "SMS daily quota reached": {
        name: "Setup Business Profile URL",
        value: "user.setupBusinessProfileURL",
        hasFallback: false,
    },
    "Lead import finished": [
        {
            name: "Lead Import Status",
            value: "user.status",
            hasFallback: false,
        },
        {
            name: "Number of inserted leads",
            value: "user.inserted",
            hasFallback: false,
        },
        {
            name: "Errors",
            value: "user.errors",
            hasFallback: false,
        },
    ],
    "Invite agent": {
        name: "Invite Link",
        value: "user.inviteLink",
        hasFallback: false,
    },
}

const systemVariables = {
    Unsubscribed: {
        name: "Unsubscribe Link",
        value: "{unsubscribeLink}",
        hasFallback: false,
    },
}

const options = computed(() => {
    const mergeFields = categories.value.map((category) => {
        return {
            name: capitalize(category.typeName),
            value: category.typeName,
            children: setChildElements(category),
        }
    })
    if (props.isTemplateTypeEmail) {
        mergeFields.push({
            name: "System",
            value: "system",
            children: Object.values(systemVariables),
        })
    }
    if (!props.specialVariable) {
        return mergeFields
    }
    mergeFields.push({
        name: "User",
        value: "user",
        children: setSpeacialVariables(),
    })
    return mergeFields
})

function setSpeacialVariables() {
    const specialVariable = specialVariableMap[props.specialVariable]
    if (Array.isArray(specialVariable)) {
        return specialVariable
    }
    return [specialVariable]
}

function addMergeField(option: CascadeChildOption) {
    let optionValue = option.value
    if (option.hasFallback) {
        optionValue = `${optionValue}:<fallback>`
    }
    emit("addMergeField", `{{${optionValue}}}`)
}

function setChildElements(category: Prototype) {
    const children =
        category.attributes?.map((attribute: Attribute) => {
            return {
                name: attribute.displayName as string,
                value: category.typeName ? `${category.typeName}.${attribute.name}` : (attribute.name as string),
                hasFallback: true,
            }
        }) ?? []
    if (category.typeName === "agent") {
        children.unshift({
            name: "Signature",
            value: "{ templateRenderedSignature }",
            hasFallback: false,
        })
    }
    return children
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GgmsCascadeSelect, {
    options: options.value,
    label: "Merge fields",
    placeholder: "Merge Fields",
    onSelect: addMergeField
  }, null, 8, ["options"]))
}
}

})